import { Api, JSUtil, Keys } from "@mcleod/core";
import { AbstractSearchFilterTextboxPanel } from "./AbstractSearchFilterTextboxPanel";
import { Image } from "../../../image/Image";
import { KeyEvent } from "../../../../events/KeyEvent";
import { Label } from "../../../label/Label";
import { Panel } from "../../../..";
import { TextboxVariant } from "../../../textbox/TextboxVariant";

enum InnerIds {
    TEXTBOX_SEARCH = "textboxSearch",
    IMAGE_SEARCH = "imageSearch",
}

export class SearchTextboxPanel extends AbstractSearchFilterTextboxPanel {
    private debouncedInvokeSearchFromServer = JSUtil.debounce(() => /*this.table._searchFromServer()*/{}, 300);
    private _filterToggledOn = false;
    private imageFunnel: Image;
    onFilterToggle: ()=>void;

    override syncInnerComponentIds() {
        this.setInnerComponentId(this.textbox, InnerIds.TEXTBOX_SEARCH);
        this.setInnerComponentId(this.image, InnerIds.IMAGE_SEARCH);
    }

    protected override createTextbox() {
        super.createTextbox();
        this.textbox.setProps({
            placeholder: "Search",
            fontSize: 16,
            captionVisible: false,
            rowBreak: false,
            variant: TextboxVariant.UNDERLINED
        });
        this.textbox.id = this.createInnerComponentId(InnerIds.TEXTBOX_SEARCH);
        this.addKeyListener();
    }

    protected override createImage() {
        super.createImage();
        this.image.setProps({
            name: "magnifyingGlass",
            color: "#9E9E9E"
        });
        this.image.id = this.createInnerComponentId(InnerIds.IMAGE_SEARCH);
    }

    get filterToggledOn(): boolean {
        return this._filterToggledOn;
    }

    private set filterToggledOn(value: boolean) {
        this._filterToggledOn = value;
        this.onFilterToggle();
    }

    private addKeyListener() {
        this.textbox.addKeyUpListener((event: KeyEvent) => {
            if (event.domEvent != null && event.key === Keys.ENTER && this.textbox.hasText())
                this.debouncedInvokeSearchFromServer();
        });
    }

    refreshTooltip() {
        if (this.table.allowDbSearch !== true) {
            this.textbox.tooltip = null;
            return;
        }
        if (this.textbox.tooltip != null)
            return;
        const dsUrl = this.table.dataSource?.url;
        if (dsUrl == null)
            return;
        const filter = { model_url: dsUrl };
        Api.search("common/quick-find-fields", filter).then(response => {
            this.textbox.tooltip = this.finalizeTooltip(response.data[0].fields);
        });
    }

    private finalizeTooltip(fields: string[]): Panel {
        const tooltipPanel = new Panel({ maxHeight: 500, scrollY: true });
        const fieldListLabel = new Label({ rowBreak: true, fillRow: true });
        tooltipPanel.add(fieldListLabel);
        if (fields == null || fields.length === 0)
            fieldListLabel.text = "Search using any field.";
        else {
            fieldListLabel.text = "Search using the following fields:";
            for (const field of fields) {
                const singleFieldLabel = new Label({ text: "  - " + field, rowBreak: true, fillRow: true });
                tooltipPanel.add(singleFieldLabel);
            }
        }
        const advancedSearchLabel = new Label({
            fillRow: true,
            text: "You may also use the advanced search option to search across multiple fields.",
            imageColor: "primaryReverse",
            imageName: "magnifyingGlassPage",
            imageHeight: 35,
            imageWidth: 35,
            marginTop: 10
        });
        tooltipPanel.add(advancedSearchLabel);
        return tooltipPanel;
    }

    updateAfterDbSearch(filterVisible: boolean) {
        // if (this.isExpanded()) {
        //     if (this.table.searchFilterMode === SearchFilterMode.EXPANDED) {
        //         if (/*this.table.allowFilter*/true) {
        //             this.initializeImageFunnel();
        //             this.textbox.imagePost = this.imageFunnel;
        //             this.syncFunnelColor(filterVisible);
        //         }
        //     }
        // }
    }

    private initializeImageFunnel() {
        if (this.imageFunnel == null) {
            this.imageFunnel = new Image({ name: "funnel", color: "primary", height: 28, width: 28 });
            this.imageFunnel.addClickListener(() => this.filterToggledOn = !this.filterToggledOn);
        }
    }

    syncFunnelColor(filterVisible: boolean) {
        if (this.imageFunnel != null)
            this.imageFunnel.color = filterVisible ? "#9E9E9E" : "primary";
    }
}
